import React, { useState, useEffect } from 'react';

import api from 'services/api';
import { useDebounce } from 'hooks/useDebounce';

import Icon from 'components/Icon';
import Spinner from 'components/Spinner';
import GridFlex from 'components/GridFlex';
import Button from 'components/Button';
import Text from 'components/Text';
import { Input } from 'components/Fields';

import ModalCreateBrand from 'components/ModalCreateBrand';

import Header from '../Header';
import ModalDeleteOrIsActive, { Types } from '../ModalDeleteOrIsActive';

import { Container } from './styles';
import { List, Item, ContainerActions, SwitchTheme } from '../styles';

interface IList {
  id: number;
  description: string;
  isActive?: boolean;
}

const endpoint = '/brands';

const Brand: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [list, setList] = useState<IList[]>([]);
  const [loading, setLoading] = useState(false);
  const [openModalIsActive, setOpenModalIsActive] = useState<Types | boolean>(
    false,
  );
  const [brandSelected, setBrandSelected] = useState<any>(false);

  const getBrands = async () => {
    setLoading(true);

    const newList: IList[] = await api.get(`${endpoint}?description=${search}`);

    setList(newList);

    setLoading(false);
  };

  const autoSave = useDebounce(search);

  const saveChange = async () => {
    getBrands();
  };

  useEffect(() => {
    saveChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSave]);

  return (
    <Container>
      <ModalCreateBrand
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSaved={() => getBrands()}
      />

      <Header
        onCreate={() => setModalOpen(true)}
        title="Brand management"
        titleCreate="Create new brand"
      />

      {!!openModalIsActive && (
        <ModalDeleteOrIsActive
          type={openModalIsActive as Types}
          endpoint={endpoint}
          itemName={brandSelected.description}
          id={brandSelected.id}
          isActive={brandSelected.isActive}
          onClose={() => setOpenModalIsActive(false)}
          onCreated={() => {
            if (openModalIsActive === Types.DELETE) {
              setList(list.filter(i => i.id !== brandSelected.id));
            }
            if (openModalIsActive === Types.ISACTIVE) {
              const newList = list;

              newList[brandSelected.index] = {
                ...newList[brandSelected.index],
                isActive: !brandSelected.isActive,
              };

              setList(newList);
            }
            setOpenModalIsActive(false);
          }}
        />
      )}

      <Input
        name="search"
        onChange={e => setSearch(e.target.value)}
        value={search}
        placeholder="Search brand"
        width="100%"
        dataTest="search"
        leftContent={
          <Icon
            icon="search"
            color="grayLightText"
            width="18px"
            height="18px"
          />
        }
      />
      <List>
        {loading ? (
          <GridFlex justifyContent="center" alignItems="center">
            <Spinner />
          </GridFlex>
        ) : (
          <>
            {list.map(({ description, id, isActive }, index) => (
              <Item key={description}>
                <Text fontSize={14} fontWeight="normal" color="black">
                  {description}
                </Text>
                <ContainerActions>
                  <SwitchTheme
                    checked={!isActive}
                    data-testid={`button-row-isActive-${id}`}
                    onClick={() => {
                      setOpenModalIsActive(Types.ISACTIVE);
                      setBrandSelected({ description, id, isActive, index });
                    }}
                  />
                  <Button
                    width="95px"
                    padding="6px 30px"
                    data-testid={`button-row-delete-${id}`}
                    onClick={() => {
                      setOpenModalIsActive(Types.DELETE);
                      setBrandSelected({ description, id, isActive, index });
                    }}
                  >
                    Delete
                  </Button>
                </ContainerActions>
              </Item>
            ))}
          </>
        )}
      </List>
    </Container>
  );
};

export default Brand;
